import React from 'react';
function LastPage() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z" }),
        React.createElement("path", { fill: "none", d: "M0 0h24v24H0V0z" })));
}
export default LastPage;
